import { render, staticRenderFns } from "./BuyerCallLogs.vue?vue&type=template&id=712b57ae&scoped=true"
import script from "./BuyerCallLogs.vue?vue&type=script&lang=js"
export * from "./BuyerCallLogs.vue?vue&type=script&lang=js"
import style0 from "./BuyerCallLogs.vue?vue&type=style&index=0&id=712b57ae&prod&lang=scss&scoped=true"
import style1 from "./BuyerCallLogs.vue?vue&type=style&index=1&id=712b57ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b57ae",
  null
  
)

export default component.exports